// imports
import * as THREE from "three"

// classes
import Experience from "../../Experience"

export default class Lights
{
    constructor()
    {
        // setup
        this.experience = new Experience()
        this.scene = this.experience.scene

        this.setAmbientLight()
    }

    setAmbientLight()
    {
        this.ambientParameters = 
        {
            color: "#ffffff",
            intensity: 1
        }

        this.ambientLight = new THREE.AmbientLight( this.ambientParameters.color, this.ambientParameters.intensity )
        this.scene.add( this.ambientLight )
    }

    setDebug()
    {
        this.folder = this.experience.world.worldFolder.addFolder( 
        {
            title: "Lights",
            expanded: false
        } ).on( "change", ( _changeInfo ) => this.handleChange( _changeInfo ) )

        this.tabs = this.folder.addTab(
        {
            pages:
            [
                { title: "Ambient" },
                { title: "...?" },
            ]
        } )

        this.ambientFolder = this.tabs.pages[0]

        this.ambientFolder.addInput( this.ambientParameters, "color" )
        this.ambientFolder.addInput( this.ambientParameters, "intensity", 
        {
            min: 0.1,
            max: 10,
            step: 0.001
        } )
    }

    handleChange( _changeInfo )
    {
        this.ambientLight.color = new THREE.Color( this.ambientParameters.color )
        this.ambientLight.intensity = this.ambientParameters.intensity
    }
} 